// Module
var code = "<svg width=\"588\" height=\"588\" xmlns=\"http://www.w3.org/2000/svg\"> <ellipse stroke=\"#4880FA\" ry=\"293.99998\" rx=\"293.99998\" id=\"svg_1\" cy=\"293.99998\" cx=\"293.99998\" fill=\"#4880FA\"/> </svg> ";
// Exports
module.exports = code;